// extracted by mini-css-extract-plugin
export var backupIcon = "_nj-1";
export var image = "_nj-0";